import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgFinancing(props: RootSvgProps) {
  return (
    <RootSvg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3406_13662)">
        <path
          d="M3.91111 11.5556L6.62222 8.84444L8.4 10.6222L11.5556 7.48889V8.88889H13.3333V4.44444H8.88889V6.22222H10.2889L8.4 8.11111L6.62222 6.33333L2.66667 10.3111L3.91111 11.5556ZM1.77778 16C1.28889 16 0.87037 15.8259 0.522222 15.4778C0.174074 15.1296 0 14.7111 0 14.2222V1.77778C0 1.28889 0.174074 0.87037 0.522222 0.522222C0.87037 0.174074 1.28889 0 1.77778 0H14.2222C14.7111 0 15.1296 0.174074 15.4778 0.522222C15.8259 0.87037 16 1.28889 16 1.77778V14.2222C16 14.7111 15.8259 15.1296 15.4778 15.4778C15.1296 15.8259 14.7111 16 14.2222 16H1.77778ZM1.77778 14.2222H14.2222V1.77778H1.77778V14.2222Z"
          fill="#1F1F1F"
        />
      </g>
      <defs>
        <clipPath id="clip0_3406_13662">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
